@use "@fukuri-admins/ui/layout" as *;

.actions {
  display: flex;
  justify-content: flex-end;
}

.searchField {
  width: 269px;
}
